export default class Grouping<TKey, TElement> extends Array<TElement> {
  public readonly key: TKey;
    
  public constructor(key: TKey, items?: Array<TElement>) {
    super(...items || []);
    this.key = key;
  }
}
